import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  dimensionMetricsSelector,
  isMetricFilterAppliedSelector,
} from '@store/trends/base/selectors';
import { useMeasure } from 'react-use';
import {
  ACTION_COL_WIDTH,
  DIMENSION_COL_WIDTH,
  METRIC_COL_WIDTH,
  SF_COL_WIDTH,
} from '../dimension-table/utils';

const BUFFER = 20;

// calc width for grid
function useCalcTableWidth() {
  const metrics = useSelector(dimensionMetricsSelector);
  const metricFilterApplied = useSelector(isMetricFilterAppliedSelector);
  const [ref, { width: parentWidth }] = useMeasure();

  const width = useMemo(() => {
    const mx = metricFilterApplied ? 2 : 0; // metric filter adds two new columns
    return Math.min(
      BUFFER +
        ACTION_COL_WIDTH +
        DIMENSION_COL_WIDTH +
        METRIC_COL_WIDTH * metrics.length +
        mx * SF_COL_WIDTH * metrics.length,
      parentWidth,
    );
  }, [metrics, metricFilterApplied, parentWidth]);

  return { ref, width };
}

export default useCalcTableWidth;
